import {combineReducers} from 'redux';

const initialState = {
  id: localStorage.getItem('sylvanus_employee_id'),
};

export const currentUserReducer = combineReducers({
  employee: currentEmployeeReducer,
});

function currentEmployeeReducer(state = initialState, action) {
  switch (action.type) {
    case 'UPDATE_CURRENT_USER_EMPLOYEE': {
      return {
        ...state,
        id: action.payload,
      };
    }
    default: 
      return state;
  }
}
